module.exports = __webpack_public_path__ + "Flag-634.65c581b70c0d6289c12ec736d065d1cc.svg";